import { appComponent } from './smd'
import ReactDOM from "react-dom"

const container = document.getElementById('container')
if (window.location.pathname === '/'){
    window.location.replace("/courses/mechanics/pendulums/lab-directions")
}
ReactDOM.render(appComponent, container)



// WEBPACK FOOTER //
// ./dev/index.jsx